
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const serviceSlice = createSlice({
    name: 'services',
    loading: false,
    initialState: {
        servicelist: []
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.servicelist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.servicelist = action.payload.data?action.payload.data:[];
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = serviceSlice.actions;
//console.log(body);
export const fetchServices = (body)=> apiCallBegan({
    url: '/service/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














